fragment CtaBlockFragment on ctaBlock_Entry {
  typeHandle

  # Content
  heading
  imageOrVideo {
    ...CraftAssetFragment
  }
  cta {
    ...LinkFragment
  }
  price
  compareAtPrice

  # Layout
  ctaBlockLayout # banner | block
  compactWidth
}
